<template lang="pug">
  v-container.px-4(styles="text-align: left")
    input(type="hidden" name="user[user_type]" v-model="userType")
    v-row.mt-4
      v-text-field(dense label="メールアドレス" required outlined type="email" name="user[email]" :value="user.email"
        hint="迷惑メール設定などをされている場合は、「 @hikipla.com 」からのメールを受け取れるようにしてください" persistent-hint)
    v-row
      v-text-field(dense label="パスワード" required type="password" outlined name="user[password]")
    v-row(v-if="userType === 0")
      v-text-field(dense label="ニックネーム" required outlined name="user[nickname]" :value="user.nickname")
    v-row(v-if="userType === 0")
      v-select(v-model="form.gender" dense :items="genderItems" required outlined label="性別")
      input(type="hidden" name="user[gender]" v-model="form.gender")
    v-row(v-if="userType === 0")
      v-select(dense :items="ageItems" required outlined label="年代" v-model="form.age")
      input(type="hidden" name="user[age]" v-model="form.age")

    v-row(v-if="userType === 1")
      v-text-field(dense label="団体名（団体名が無ければ居場所の名称）" required outlined name="user[toujishakai_name]" :value="user.toujishakai_name")
    v-row(v-if="userType === 2")
      v-text-field(dense label="団体名" required outlined name="user[volunteer_name]" :value="user.toujishakai_name")
    v-row(v-if="userType !== 0")
      v-text-field(dense label="担当者名" required outlined name="user[tanto_name]" :value="user.tanto_name")

    v-row
      v-btn(@click="term()" x-small text)
        |利用規約
        v-icon fa-solid fa-up-right-from-square
    v-row
      v-btn(@click="policy()" x-small text) プライバシーポリシー
    v-row
      v-checkbox(v-model="agree" label="上記の規約に同意する" )

    v-row(class="justify-end")
      v-btn(color="primary" :elevation="0" block type="submit" name="commit" :disabled="!agree") 登録認証メールを送信する

</template>

<script type="module">

export default {
  props: {
    userType: {
      type: Number,
      required: true,
      default: 0
    },
    user: {
      type: Object,
      required: true,
      default: {}
    },
    genderItems: {
      type: Array,
      required: true
    },
    ageItems: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      agree: false,
      form: {
        gender: "",
        age: ""
      }
    }
  },
  created () {
    this.form = {
      gender: this.user.gender,
      age: this.user.age
    }
  },
  methods: {
    policy() {
      window.open('/rules/privacy')
    },
    term() {
      window.open('/rules/termofuse')
    },
  }
}
</script>
